import axios from 'utils/axios';
import { AxiosResponse } from 'axios';

export const getServicePackagesAccess = (): Promise<AxiosResponse> => {
  return axios.get(`/api/v1/servicepackages/access`);
};
